var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CenteredButton from '../CenteredButton';

var Menu = function (_Component) {
  _inherits(Menu, _Component);

  function Menu(props) {
    _classCallCheck(this, Menu);

    var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props));

    _this.onClick = function (e) {
      var onClick = _this.props.onClick;

      onClick(e);
    };

    _this.intervall = null;

    _this.state = {
      selectedValue: 0
    };
    return _this;
  }

  _createClass(Menu, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      this.intervall = setInterval(function () {
        _this2.setState({
          selectedValue: (_this2.state.selectedValue + 1) % _this2.props.values.length
        });
      }, 200);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.intervall);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      if (this.props.paused !== nextProps.paused) {
        if (nextProps.paused) {
          clearInterval(this.intervall);
          this.setState({
            selectedValue: nextProps.showOnPause
          });
        } else {
          this.intervall = setInterval(function () {
            _this3.setState({
              selectedValue: (_this3.state.selectedValue + 1) % _this3.props.values.length
            });
          }, 200);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          values = _props.values,
          className = _props.className;
      var selectedValue = this.state.selectedValue;


      return React.createElement(CenteredButton, { onClick: this.onClick, icon: values[selectedValue], className: className, theme: 'tooltipRound' });
    }
  }]);

  return Menu;
}(Component);

export default Menu;


Menu.propTypes = process.env.NODE_ENV !== "production" ? {
  values: PropTypes.PropTypes.arrayOf(PropTypes.string).isRequired,
  paused: PropTypes.bool,
  showOnPause: PropTypes.number,
  className: PropTypes.string,

  onClick: PropTypes.func
} : {};

Menu.defaultProps = {
  paused: false,
  showOnPause: 0,
  className: '',

  onClick: function onClick() {}
};